module.exports = __webpack_public_path__ + "img/rotate.9cbd4508.png";